<template>
  <div class="flex flex-col gap-4">
    <h2 v-if="pro.bio" class="text-lg text-grayscale-96 font-bold">Bio</h2>
    <div v-if="pro.bio" class="text-15 leading-140">
      <p ref="bioText" class="text-grayscale-90">
        {{ bio }}
        <span
          v-if="isReadText"
          class="text-grayscale-96 whitespace-nowrap underline cursor-pointer"
          @click="switchText"
        >
          {{ isMore ? "Show Less" : "Show More" }}
        </span>
      </p>
    </div>
    <div v-if="pro.genres?.length" class="text-sm text-grayscale-90 gap-1">
      <h2 class="inline mr-1">Genres:</h2>
      <p class="font-bold inline">{{ pro.genres.join(", ") }}</p>
    </div>
    <div
      v-if="Object.values(pro?.socialLinks || {}).filter(Boolean).length"
      class="w-full"
    >
      <socials :user="pro" class="gap-2 flex-wrap" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import type { PropType } from "vue";
import type { User } from "../../../types/user";
import Socials from "@/components/profile/industry-pro/Socials.vue";

const props = defineProps({
  pro: {
    type: Object as PropType<User>,
    required: true,
  },
});

const isMore = ref(false);
const bioText = ref<HTMLParagraphElement>();
const characterNumbers = ref();
const isReadText = ref(false);
const bioLongText = computed(() => props.pro.bio?.trim() || "");
const bio = ref();

const getCharacters = () => {
  const paragraphsWidth = bioText.value?.clientWidth;
  if (paragraphsWidth) {
    characterNumbers.value = Math.round((3 * paragraphsWidth) / 5.2 - 70);
  }
  setBioText();
};

const setBioText = () => {
  if (bioLongText.value.length <= characterNumbers.value) {
    bio.value = bioLongText.value;
    return;
  }

  isReadText.value = true;

  if (isMore.value) {
    bio.value = bioLongText.value;
    return;
  }

  bio.value = bioLongText.value
    .slice(0, characterNumbers.value)
    .concat(" ", "...");
};

const switchText = () => {
  isMore.value = !isMore.value;
  setBioText();
};

watch(
  () => bioText.value?.clientWidth,
  () => getCharacters(),
);

onMounted(() => {
  getCharacters();
});
</script>
